import { EventEmitter } from '@comeon/utility';

const BASE_URL = window.location.origin;
export const NOTIFICATION_ENDPOINT = `${BASE_URL}/auto/sow/kreditz/notification?caseId=`;

export const USER_FLOW_COMPLETED = {
	status: 'success',
	userFlowCompleted: 'User flow completed',
	userFlowCancelled: 'user cancelled bank authentication',
	bankingAuthStarted: 'banking authentication started',
	bankingAuthFinished: 'banking authentication finished'
};

export const COMPLETED = 'completed';
export const FAILED = 'failed';
export const INCOMPLETE = 'incomplete';

export const NOTIFICATION_ID = 'spending-limit';

export const ndlEventStream = EventEmitter('spending-limit');

export enum NotificationEvents {
	notification = 'notification'
}

export enum NotificationStatus {
	completed = 'completed',
	failed = 'failed',
	incomplete = 'incomplete'
}
